
<div class="form-group">
  <label for="name">Nom</label>
  <input #nameInput id="name" type="text" placeholder="" [formControl]="name" maxlength="200"/>
  <span class="info info-error" [hidden]="name.valid || name.pristine || !name.errors.required">Ce champ est requis</span>
</div>

<div class="form-group" *ngIf="!entity.id">
  <label>Type</label>
  <t-option [options]="entityTypeOptions" [(value)]="entity.type"></t-option>
</div>

<div class="form-group" *ngIf="entity.id">
  <label for="type">Type</label>
  <span id="type" class="value">{{ entity.type | slentitytype }}</span>
</div>

<div class="form-group" *ngIf="entity.type === 'COMPANY'">
  <label for="rcs">RCS</label>
  <input id="rcs" type="text" placeholder="" [(ngModel)]="entity.rcs" maxlength="200"/>
</div>

<div class="form-group" *ngIf="entity.id">
  <label for="version">Version</label>
  <span id="version" class="value">{{ entity.version }}</span>
</div>

<div class="form-group address">
  <label for="line1">Adresse</label>
  <input id="line1" class="address-line-1" type="text" placeholder="Ligne 1" [formControl]="line1" maxlength="200"/>
  <span class="info info-error" [hidden]="line1.valid || line1.pristine || !line1.errors.required">Ce champ est requis</span>

  <input id="line2" class="address-line-2" name="line2" type="text" placeholder="Ligne 2" [(ngModel)]="entity.address.line2" maxlength="200"/>

  <input id="line3" class="address-line-3" name="line3" type="text" placeholder="Ligne 3" [(ngModel)]="entity.address.line3" maxlength="200"/>

  <div class="input-line">
    <input id="zip" name="zip" type="text" placeholder="Code postal" [(ngModel)]="entity.address.zip" maxlength="200"/>

    <input id="city" name="city" type="text" placeholder="Ville" [(ngModel)]="entity.address.city" maxlength="200"/>
  </div>

  <t-select [items]="countries" [(item)]="entity.address.country"></t-select>

</div>

<div class="form-group">
  <label for="email">Email</label>
  <input id="email" type="text" placeholder="" [(ngModel)]="entity.email" maxlength="200"/>
</div>

<div class="form-group">
  <label for="phone">Téléphone</label>
  <input id="phone" type="text" placeholder="" [(ngModel)]="entity.phone" maxlength="200"/>
</div>